module.exports = "../fonts/HelveticaNeueLTW01-65Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-65Medium.woff
// module id = GKUe
// module chunks = 1